import { Component, inject, input, computed, signal, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { ChannelService, ParameterService } from '@frontend/frontendlib';

@Component({
  selector: 'app-choosepayment',
  templateUrl: './choosepayment.component.html',
  styleUrls: ['./choosepayment.component.css'],
})
export class ChoosepaymentComponent implements OnInit 
{

  openPaymentproviderId = '';
  show_details = false;
  error = 0;
  mehr_text = input('');
  isAbgelaufen = signal(false);

  public readonly parameterService = inject(ParameterService);
  public readonly currencyPipe = inject(CurrencyPipe);
  private readonly channelService = inject(ChannelService);
  
  ngOnInit(): void {
    this.parameterService.runGoogleTag('begin_checkout');
  }

  header = computed(() => this.channelService.getHeader());
  headerLine1 = computed(() => this.channelService.getHeaderLine1());
  headerLine2 = computed(() => this.channelService.getHeaderLine2());

  mehrTextCalculated = computed(() => (this.mehr_text() ?? '') === '' ? 'mehr' : this.mehr_text());

  toogle_show_details() {
    this.show_details = this.show_details === true ? false : true;
  }

  togglePaymentprovider(id: string) {
    this.openPaymentproviderId = this.openPaymentproviderId === id ? '' : id;
    this.parameterService.coupon_input = false;
  }

  setAbgelaufen() {
    this.isAbgelaufen.set(true);
  }
}